/* generated by pull.js */
const manifest = {
  editorOnly: true,
  noTranslations: true,
  name: 'Disable compiler in editor',
  description:
    'Turns off the compiler by default in the script editor. It can still be manually enabled through the "Advanced" menu bar button.',
  userscripts: [
    {
      url: 'userscript.js'
    }
  ],
  tags: ['danger'],
  enabledByDefault: false
};
export default manifest;
